/* global window */
import { RefObject, useEffect, useRef } from 'react';
import useEventListener from './useEventListener';

const useInView = (onInView: undefined | (() => void), el: RefObject<any>, data: any) => {
  const isInView = useRef<boolean>(false);

  const onScroll = () => {
    if (onInView && el.current && !data && !isInView.current) {
      const distance = el.current.getBoundingClientRect().top - window.innerHeight;
      if (distance < 500) {
        isInView.current = true;
        onInView();
      }
    }
  };

  useEffect(onScroll, []);
  useEventListener('scroll', onScroll);

  return isInView.current;
};

export default useInView;
